import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';

export default class GetInvitesForUser extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-getInvitesForUser',
      payload: {
        user_id: this._payload.user_id,
      },
      disableLoaders: true
    });
  }

  onSuccess(data) {
    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        user: {
          groupInvites: data || []
        }
      }
    })
    super.onSuccess(data);
  }
}
